export function removeEmpty<T>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj)
      .map(([key, value]) => {
        if (value === null || value === undefined) {
          return undefined; // drop it
        }

        if (typeof value === 'string' && value.trim() === '') {
          return undefined;
        }

        if (Array.isArray(value)) {
          const cleanedArray = value.filter((item) => item !== null && item !== undefined);
          return cleanedArray.length > 0 ? [key, cleanedArray] : undefined;
        }

        if (typeof value === 'object' && value !== null) {
          const cleaned = removeEmpty(value);
          return Object.keys(cleaned).length > 0 ? [key, cleaned] : undefined;
        }

        return [key, value];
      })
      .filter(Boolean) as [string, any][],
  );
}
